module.exports = __webpack_public_path__ + "img/王富晓.33b362ef.jpg";